import {z} from 'zod';

export const StoreLocationsParams = z.object({
  'page[number]': z.coerce.string(),
  'page[size]': z.coerce.string(),
  'sort[latitude]': z.coerce.string(),
  'sort[longitude]': z.coerce.string(),
  'filter[maxRadius]': z.coerce.string(),
  'filter[crmLabel.name]': z.coerce.string(),
  'filter[isB2BArchived]': z.coerce.string().default('false'),
  'filter[brands]': z.array(z.string()).optional(),
});

export type StoreLocationsParams = z.infer<typeof StoreLocationsParams>;

export const getQueryParams = (params: StoreLocationsParams): URLSearchParams => {
  const query = new URLSearchParams();
  query.set('page[number]', params['page[number]']);
  query.set('page[size]', params['page[size]']);
  query.set('sort[latitude]', params['sort[latitude]']);
  query.set('sort[longitude]', params['sort[longitude]']);
  query.set('filter[maxRadius]', params['filter[maxRadius]']);
  query.set('filter[crmLabel.name]', params['filter[crmLabel.name]']);
  query.set('filter[isB2BArchived]', params['filter[isB2BArchived]']);
  if (params['filter[brands]'] && params['filter[brands]'].length > 0) {
    params['filter[brands]'].forEach(brand => {
      query.append('filter[brands]', brand);
    });
  }
  return query;
}

export const getStoreLocationsParams =(
  page: number, size: number,
  latitude: number, longitude:number,
  maxRadius: number, crmLabelName: string,
  isB2BArchived: boolean = false, allowedBrands?: string[]
): StoreLocationsParams =>{
  return StoreLocationsParams.parse({
    'page[number]': page,
    'page[size]': size,
    'sort[latitude]': latitude,
    'sort[longitude]': longitude,
    'filter[maxRadius]': maxRadius,
    'filter[crmLabel.name]': crmLabelName,
    'filter[isB2BArchived]': isB2BArchived,
    'filter[brands]': allowedBrands || undefined,
  });
}

